module.exports = __webpack_public_path__ + "img/branding_contents1.9182f599.png";